export default __webpack_public_path__ + "static/media/hindola-mahal-Mandu.bfb59c8f.jpg";